(function () {
  document.querySelectorAll('.dp-slider').forEach(function (slider) {
    var slides = slider.querySelectorAll('.dp-slider__slide');
    var dots = slider.querySelectorAll('.dp-slider__dot');
    var prevBtn = slider.querySelector('.dp-slider__arrow--prev');
    var nextBtn = slider.querySelector('.dp-slider__arrow--next');
    if (slides.length <= 1) return;

    var current = 0;
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(slider.getAttribute('data-speed'), 10) || 5000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
})();